import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkProgrammesFileType {
    UPLOAD_BULK_PROGRAMMES_FILE = "@@auth/UPLOAD_BULK_PROGRAMMES_FILE",
    UPLOAD_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/UPLOAD_BULK_PROGRAMMES_FILE_SUCCESS",
    UPLOAD_BULK_PROGRAMMES_FILE_ERROR = "@@auth/UPLOAD_BULK_PROGRAMMES_FILE_ERROR",
    RESET_UPLOAD_BULK_PROGRAMMES_FILE = "@@auth/RESET_UPLOAD_BULK_PROGRAMMES_FILE",

    FETCH_BULK_PROGRAMMES_FILE = "@@auth/FETCH_BULK_PROGRAMMES_FILE",
    FETCH_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/FETCH_BULK_PROGRAMMES_FILE_SUCCESS",
    FETCH_BULK_PROGRAMMES_FILE_ERROR = "@@auth/FETCH_BULK_PROGRAMMES_FILE_ERROR",
    RESET_FETCH_BULK_PROGRAMMES_FILE = "@@auth/RESET_FETCH_BULK_PROGRAMMES_FILE",

    BULK_PROGRAMMES_FILE_DOWNLOAD = "@@auth/BULK_PROGRAMMES_FILE_DOWNLOAD",
    BULK_PROGRAMMES_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_PROGRAMMES_FILE_DOWNLOAD_SUCCESS",
    BULK_PROGRAMMES_FILE_DOWNLOAD_ERROR = "@@auth/BULK_PROGRAMMES_FILE_DOWNLOAD_ERROR",
    RESET_BULK_PROGRAMMES_FILE_DOWNLOAD = "@@auth/RESET_BULK_PROGRAMMES_FILE_DOWNLOAD",

    FETCH_BULK_PROGRAMMES_FILE_DETAIL = "@@auth/FETCH_BULK_PROGRAMMES_FILE_DETAIL",
    FETCH_BULK_PROGRAMMES_FILE_DETAIL_SUCCESS = "@@auth/FETCH_BULK_PROGRAMMES_FILE_DETAIL_SUCCESS",
    FETCH_BULK_PROGRAMMES_FILE_DETAIL_ERROR = "@@auth/FETCH_BULK_PROGRAMMES_FILE_DETAIL_ERROR",
    RESET_FETCH_BULK_PROGRAMMES_FILE_DETAIL = "@@auth/RESET_FETCH_BULK_PROGRAMMES_FILE_DETAIL",

    BULK_PROGRAMMES_FILE_VERSION = "@@auth/BULK_PROGRAMMES_FILE_VERSION",
    BULK_PROGRAMMES_FILE_VERSION_SUCCESS = "@@auth/BULK_PROGRAMMES_FILE_VERSION_SUCCESS",
    BULK_PROGRAMMES_FILE_VERSION_ERROR = "@@auth/BULK_PROGRAMMES_FILE_VERSION_ERROR",
    RESET_BULK_PROGRAMMES_FILE_VERSION = "@@auth/RESET_BULK_PROGRAMMES_FILE_VERSION",

    PUBLISH_BULK_PROGRAMMES_FILE = "@@auth/BULK_PROGRAMMES_FILE_PUBLISH",
    PUBLISH_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/PUBLISH_BULK_PROGRAMMES_FILE_SUCCESS",
    PUBLISH_BULK_PROGRAMMES_FILE_ERROR = "@@auth/PUBLISH_BULK_PROGRAMMES_FILE_ERROR",
    RESET_PUBLISH_BULK_PROGRAMMES_FILE = "@@auth/RESET_PUBLISH_BULK_PROGRAMMES_FILE",

    APPROVE_BULK_PROGRAMMES_FILE = "@@auth/APPROVE_BULK_PROGRAMMES_FILE",
    APPROVE_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/APPROVE_BULK_PROGRAMMES_FILE_SUCCESS",
    APPROVE_BULK_PROGRAMMES_FILE_ERROR = "@@auth/APPROVE_BULK_PROGRAMMES_FILE_ERROR",
    RESET_APPROVE_BULK_PROGRAMMES_FILE = "@@auth/RESET_APPROVE_BULK_PROGRAMMES_FILE",

    REJECT_BULK_PROGRAMMES_FILE = "@@auth/REJECT_BULK_PROGRAMMES_FILE",
    REJECT_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/REJECT_BULK_PROGRAMMES_FILE_SUCCESS",
    REJECT_BULK_PROGRAMMES_FILE_ERROR = "@@auth/REJECT_BULK_PROGRAMMES_FILE_ERROR",
    RESET_REJECT_BULK_PROGRAMMES_FILE = "@@auth/RESET_REJECT_BULK_PROGRAMMES_FILE",

    FETCH_BULK_FILE_SPECIFIC_PROGRAMMES = "@@auth/FETCH_BULK_FILE_SPECIFIC_PROGRAMMES",
    FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_PROGRAMMES = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_PROGRAMMES",

    DELETE_BULK_PROGRAMMES_FILE = "@@auth/DELETE_BULK_PROGRAMMES_FILE",
    DELETE_BULK_PROGRAMMES_FILE_SUCCESS = "@@auth/DELETE_BULK_PROGRAMMES_FILE_SUCCESS",
    DELETE_BULK_PROGRAMMES_FILE_ERROR = "@@auth/DELETE_BULK_PROGRAMMES_FILE_ERROR",
    RESET_DELETE_BULK_PROGRAMMES_FILE = "@@auth/RESET_DELETE_BULK_PROGRAMMES_FILE",

}

// Action Types
export type BulkProgrammesFileAction = {
    type:
    | bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_UPLOAD_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD
    | bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_DOWNLOAD

    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL
    | bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE_DETAIL

    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION
    | bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_VERSION

    | bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_PUBLISH_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_APPROVE_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_REJECT_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES
    | bulkProgrammesFileType.RESET_FETCH_BULK_FILE_SPECIFIC_PROGRAMMES

    | bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.RESET_DELETE_BULK_PROGRAMMES_FILE;


    payload: any;
};

export type uploadBulkProgrammesFileType = {
    bulkProgrammesFile: File;
}

export type BulkProgrammesDownloadFileType = {
    downloadURL: string
}
export type BulkProgrammesFileDetail = {
    externalID: string,
}
export type BulkProgrammesFileVersionType = {
    externalId: string,
    filter: FilterMetadata
}
export type BulkProgrammesFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string },
    externalId: string
}
export type BulkProgrammesFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string },
    externalId: string
}


// Saga Types
export type uploadBulkProgrammesFileSaga = {
    type: string,
    payload: uploadBulkProgrammesFileType
}

export type fetchBulkProgrammesFileSaga = {
    type: string,
    payload: FilterMetadata
}
export type downloadBulkProgrammesFileSaga = {
    type: string,
    payload: BulkProgrammesDownloadFileType
}
export type fetchBulkProgrammesFileDetailSaga = {
    type: string,
    payload: BulkProgrammesFileDetail
}
export type BulkProgrammesFileVersionSaga = {
    type: string,
    payload: BulkProgrammesFileVersionType
}
export type BulkProgrammesFileMakerRemarkSaga = {
    type: string,
    payload: BulkProgrammesFileMakerRemarkType
}
export type BulkProgrammesFileCheckerRemarkSaga = {
    type: string,
    payload: BulkProgrammesFileCheckerRemarkType
}



// Reducer Types
type reducerPayload = {
    data: FetchApiResponse<any>; // Future option: FetchApiResponse<any> | Record<string, unknown>
    error: string;
}

export type BulkProgrammesFileReducer = {
    type:
    | bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_UPLOAD_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD
    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_SUCCESS
    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_ERROR
    | bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_DOWNLOAD

    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL
    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_SUCCESS
    | bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_ERROR
    | bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE_DETAIL

    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION
    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_SUCCESS
    | bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_ERROR
    | bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_VERSION

    | bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_PUBLISH_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_APPROVE_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_REJECT_BULK_PROGRAMMES_FILE

    | bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES
    | bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_SUCCESS
    | bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_ERROR
    | bulkProgrammesFileType.RESET_FETCH_BULK_FILE_SPECIFIC_PROGRAMMES

    | bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE
    | bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_SUCCESS
    | bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_ERROR
    | bulkProgrammesFileType.RESET_DELETE_BULK_PROGRAMMES_FILE

    payload: reducerPayload;
};

export type BulkProgrammesFileReducerStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<any>;
    error?: string | null;
};
export type BulkProgrammesFileReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<any>;
    error?: string | null;
};
